import { Outlet } from 'react-router-dom';

import { Layout as LayoutAntd } from 'antd';

import Drawer from '@/components/globals/Layout/Drawer';
import Footer from '@/components/globals/Layout/Footer';
import Header from '@/components/globals/Layout/Header';
import Menu from '@/components/globals/Layout/Menu';
import { isMainSubdomain } from '@/settings';
import styled, { StyledProp } from '@/styled';

interface LayoutProps extends StyledProp {}

export const navbarItems = [
  {
    path: '/resumo',
    label: 'Resumo'
  },
  {
    path: '/cursos',
    label: 'Meus Cursos'
  },
  {
    path: '/portais',
    label: 'Portais'
  },
  {
    path: '/certificados',
    label: 'Certificados'
  },
  {
    path: '/aulas/salvas',
    label: 'Aulas Salvas'
  },
  {
    path: '/notas',
    label: 'Minhas Anotações'
  }
].filter(item => {
  if (isMainSubdomain) return item;
  return item.path !== '/portais';
});

const Layout = ({ ...rest }: LayoutProps) => {
  return (
    <LayoutAntd {...rest}>
      <Header />
      <Drawer />
      <LayoutAntd.Content>
        <Menu />
        <Outlet />
      </LayoutAntd.Content>
      <Footer />
    </LayoutAntd>
  );
};

export default styled(Layout)`
  min-height: 100vh;
  transition: ${({ theme }) => theme.motionDurationMid};

  main {
    margin-top: ${({ theme }) => theme.variables.headerHeight}px;
  }
`;
